import { required } from 'vuelidate/lib/validators'
import { slugValidator, slugAsyncValidator, validationErrorMessages } from '@/utils/validations/validations'
import pagesSlugsQuery from '@/services/gql/types/Pages/queries/pagesSlugs.gql'

export default ({ id, ctx, isNew }) => {
  const isUnique = async (value) => {
    return await slugAsyncValidator(value, id, pagesSlugsQuery, ctx, 'pages')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    title: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: { validator: slugValidator, message: validationErrorMessages.slugGeneralMsg },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })()
  }
}
